import { render, staticRenderFns } from "./GoBackUp.vue?vue&type=template&id=2f0c763e&"
import script from "./GoBackUp.vue?vue&type=script&lang=js&"
export * from "./GoBackUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports